module.exports = __webpack_public_path__ + "static/media/Piglet_Idle.05920923.png";